module.exports = __webpack_public_path__ + "static/media/girgies.0a880283.jpeg";